<template>
  <div class="page-header shared-page-header">
    <div class="shared-page-header-title">
      <slot name="title"></slot>
    </div>
    <div class="buttons shared-page-header-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.shared-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.shared-page-header-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

::v-deep .shared-page-header-actions .btn {
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
}

::v-deep .shared-page-header-actions .btn-group .btn {
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
}

@media (max-width: 1400px) {
  .shared-page-header-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
